export const badgeStyles = [
  'primary',
  'secondary',
  'success',
  'danger',
  'warning',
  'info',
  'dark',
  'gray',
  'light',
];
